"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translation = void 0;
var _translation;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var translation = (_translation = {
  400: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  401: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  403: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  404: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  500: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  501: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  At: "at",
  No: "No",
  at: "At",
  is: "is",
  of: "of",
  xs: "xs",
  to: "to",
  noImage: "No Image",
  catering: 'Catering',
  Yes: "Yes",
  eng: "ENG",
  "for": "for",
  map: "Map",
  "new": "NEW",
  phc: "restrooms for physically enabled",
  tab: "tab",
  upi: "upi",
  veg: "Veg",
  from: "from",
  till: "till",
  remove: "Remove",
  Okay: "Okay",
  asap: "ASAP",
  cart: "Cart",
  date: "Date",
  done: "Done",
  edit: "Edit",
  help: "help",
  home: "Home",
  list: "List",
  more: "More",
  noon: "NOON",
  oops: "Oops!",
  save: "Save",
  text: "This is first popover",
  time: "Time",
  view: "View",
  when: "When",
  wifi: "wifi service",
  apply: "Apply",
  close: "Close",
  ecard: "ECard",
  email: "Email*",
  items: "ITEMS",
  local: "en-US",
  login: "Login",
  offer: "Offer",
  order: "Order",
  payTm: "paytm",
  reset: "Reset",
  retry: "Retry",
  sorry: "Sorry,",
  timer: "timer",
  today: "Today",
  total: "Total:",
  Cancel: "Cancel",
  Submit: "Submit",
  Viewed: "Viewed",
  button: "Button",
  callUs: "Call Us",
  cancel: "Cancel",
  change: "Change",
  closed: "Closed",
  dineIn: "Dine In",
  donate: "Donate",
  expand: "expand time choices",
  goBack: "Go Back",
  inCart: "In cart",
  kfcTxt: "KFC",
  kiosks: "kiosks",
  myCart: "My Cart",
  nonveg: "Non veg",
  redeem: "Redeem",
  refill: "refill",
  signIn: "Sign In",
  signUp: "Sign Up",
  sortBy: "Sort By",
  upSize: "Upsize your drink?",
  update: "UPDATE",
  viewed: "Viewed",
  wallet: "Wallet",
  weHave: "We have",
  zoomIn: "Zoom In",
  Payment: "Payment",
  account: "Account",
  addhope: "Add Hope",
  address: "Addresses",
  balance: "Balance",
  cartAdd: "increase quantity by 1 for",
  cartGst: "GST",
  checked: "Checked",
  confirm: "Confirm",
  afterNoon: "AFTERNOON",
  cvvText: "CVV*",
  dietary: "Dietary",
  editbox: "editbox",
  editing: "editing",
  evening: "EVENING",
  findKfc: "Find a KFC",
  getHelp: "Get Help",
  heading: "heading",
  kfc: "KFC Menu",
  kfcNews: "KFC news and announcements",
  message: "Messages",
  morning: "MORNING",
  nearYou: "KFC near you",
  oneItem: "ITEM(S)",
  openPDP: "Open PDP",
  openPLP: "Open PLP",
  parking: "parking",
  payCash: "pay-by-cash",
  payment: "Payment",
  phonePe: "phonepe",
  receipt: "Receipt",
  signOut: "Sign Out",
  todayAt: "Today at ",
  updated: "UPDATED",
  validTo: "Valid to",
  viewMap: "View map",
  weFound: "WE FOUND",
  weSaved: "We saved this order as an occasion",
  zoomOut: "Zoom Out",
  address2: "House No/ Society/ Street Name*",
  birthday: "birthday",
  carousal: "carousel view enabled",
  cartItem: "Item",
  checkBox: "checkBox",
  checkout: "CHECKOUT",
  clearAll: "Clear All",
  collapse: "collapse time choices",
  "continue": "Continue",
  delivery: "Delivery",
  dineInAt: "Dine-in At",
  editName: "Edit name",
  emptyCvv: "Enter CVV number",
  emptyMsg: "Please enter your occasion name.",
  emptyPin: "Enter pin number",
  expanded: "expanded",
  filterBy: "Filter By",
  freeWifi: "free wifi",
  fullName: "Full Name*",
  fullname: "fullname* editbox",
  giftCard: "Gift Card",
  kfcImage: "kfc image",
  kfcLover: "KFC LOVER",
  listview: "listview enabled",
  loadMore: "Load More",
  mmddText: "MM / YY*",
  onlyText: "only text",
  orderMsg: "orci, eget tempus risus.",
  orderNow: "Order Now",
  readLess: "Read Less -",
  readMore: "Read More +",
  restroom: "restroom",
  savedkfc: "SAVED KFC",
  schedule: "SCHEDULE",
  selected: "selected",
  subTotal: "Subtotal",
  takeAway: "Pick up",
  takeaway: "Pick up",
  terraces: "terraces",
  tomorrow: "Tomorrow",
  viewCart: "View Cart",
  viewMenu: "View menu",
  EnteraCVV: "Enter CVV number",
  addCoupon: "Add a Coupon",
  addToCart: "Add to Cart",
  apiButton: "Call API",
  breakfast: "breakfast",
  cartItems: "Items",
  cartTitle: "CART",
  changeCap: "Change",
  collapsed: "collapsed",
  completed: "Completed",
  contactUs: "Contact Us",
  driveThru: "driveThru",
  emptyName: "Enter your Name",
  enterCode: "Enter Code",
  enterName: "Please enter name",
  foodCourt: "Food Court",
  giveAName: " give it a name!",
  greetings: "Hello",
  hometitle: "HOME",
  instaLink: "instagram link",
  leaveText: "Leave",
  leftArrow: "left arrow",
  letUsKnow: "Let us know you better",
  menuTitle: "KFC Menu",
  moreTitle: "MORE",
  myAccount: "My Account",
  offerDeal: "Deals & Offers",
  onlyImage: "only image",
  openUntil: "Open Until",
  orderFrom: "ORDER FROM",
  orderHash: "Order#",
  orderType: "ORDER TYPE",
  pinNumber: "Pin Number*",
  saveOrder: "Save This Order",
  scheduled: "Scheduled",
  selectDay: "SELECT A DAY",
  selectKFC: "SELECT A KFC",
  todayASAP: "Today, ASAP",
  topSeller: "TOP SELLER",
  unChecked: "unChecked",
  wantToAdd: "Want to add or modify?",
  welcomeTo: "WELCOME TO ",
  yourOrder: "Your Order",
  addACoupon: "Add a Coupon",
  arrowImage: "Arrow",
  backButton: "Back",
  backToCart: "Back to Cart",
  backToMenu: "Back to Menu",
  browseMenu: "Browse Menu",
  cardExpiry: "MM / YYYY*",
  cartRemove: "Remove",
  closedNext: "Open Tomorrow",
  creditCard: "credit-card",
  deliveryTo: "Delivery To",
  dineInInfo: "DINE IN INFO",
  emailLabel: "Email",
  expiredMsg: "Hurry up! This exclusive coupon is expiring soon!",
  giftAmount: "GIFT AMOUNT",
  giftpinNum: "Pin Number",
  handItToMe: "Hand it to me",
  hiddenText: "KFC | Order KFC Chicken Online & Find Restaurants",
  invalidCvv: "Invalid CVV number",
  invalidMsg: "Name must have minimum 3 and maximum 20 characters. Special characters Not allowed.",
  invalidPin: "Invalid Pin",
  itemUnaval: "Items are unavailable.",
  myFavorite: "My Favorite Menu",
  netbanking: "net-banking",
  offerDeals: "OFFERS & DEALS",
  outOfStock: "Out of Stock",
  placeOrder: "Place Order",
  playground: "playground",
  processing: "PROCESSING",
  quickOrder: "Quick Reorder",
  reorderBtn: "Reorder",
  rightArrow: "right arrow",
  savedOrder: "Saved this order in",
  searchMenu: "Search our menu",
  selectTime: "SELECT A TIME",
  signUpText: "Sign Up",
  socialIcon: "social icons view",
  startOrder: "Start Order",
  takeMeHome: "Take Me Home",
  trackOrder: "Track Order",
  unselected: "unselected",
  useAddress: "Use this Address",
  viewOffers: "View",
  wantToKnow: "What would you like to know?",
  yourAllSet: "YOU’RE ALL SET",
  yourSearch: "YOUR SEARCH",
  aSecondText: "A SECOND.",
  addHopeLogo: "Add Hope Logo",
  addHopeText: "Our goal is to feed 20 million people by 2022.",
  addedToCart: "added to cart!",
  addressHint: "Entering text into the input field will trigger the suggestions of address",
  balanceText: "Balance:",
  bucketEmpty: "Oops ! looks like there is no order history for you. Lets start an order",
  buyGiftCard: "Buy Another Gift Card",
  cartAllHope: "All Hope",
  cartViewAll: "View All",
  clearSearch: "Clear Search",
  closeButton: "Close button",
  contactInfo: "CONTACT INFO",
  contactless: "contactless",
  delToastMsg: "Successfully Your Occasion Delete",
  disposition: "disposition",
  downloadApp: "Download App",
  emptyExpiry: "Enter Expiry Date",
  errorButton: "Tap me to see an error handler",
  findOpenKfc: "Find Open KFC",
  giftCardnum: "Gift Card Number",
  goodEvening: "Good Evening",
  information: "INFORMATION",
  invalidCard: "Please Enter a Valid Card Number",
  invalidName: "Invalid Name",
  keepShoping: "Keep Shopping",
  kfcGiftCard: "KFC gift card",
  letsgetcook: "LET'S GET COOKIN'",
  myOccasions: "MY OCCASIONS",
  no_internet: "We're sorry, we're having trouble with your connection. Please check your WiFi or cellular service and try again.",
  notSelected: "not selected",
  orderLookup: "Order lookup",
  otherWallet: "other-wallet",
  phoneNumber: "Phone Number*",
  productItem: "Sorry, this food item is",
  refineItems: "Refine Items",
  reorderCaps: "REORDER",
  selectStore: "Select your store",
  signInToast: "Thank you for signing up! Happy to have you!",
  sorryUnaval: "Sorry, some items become unavailable.",
  storeClosed: "Sorry, %storeName% is currently closed. Please select a different store or order during working hours",
  twitterLink: "twitter link",
  unavailable: "Unavailable",
  upSellTitle: "We Think You’ll Love These",
  viewAllDeal: "View All Deals",
  viewAllMenu: "View All Menu",
  viewReceipt: "View Receipt",
  viewallFaqs: "View all FAQs",
  viewdetails: "View Details",
  walkInStore: "Pick up from the store",
  DineInStore: "Walk-In the Store",
  welcomeBack: "WELCOME ",
  whenYouHere: "WHEN YOU’RE HERE.",
  CVVisinvalid: "CVV is invalid",
  DiscountText: "Discount",
  GoBackToCart: "and click Back to Cart to go back Cart section.",
  GoToHomePage: "Go to HomePage",
  KfcToYourCar: "KFC to Your Car",
  accountTitle: "ACCOUNT",
  cartCheckout: "Checkout",
  cartIncluTax: "Restaurant Handling (Incl. taxes)",
  cartInfoText: "Menu pricing varies between order types.",
  cartSubTotal: "Subtotal",
  cartfaqtitle: "FAQ",
  changedPrice: "Items have changed price.",
  checkBalance: "Check Balance",
  closePopOver: "Tap me to close popover1",
  closedStatus: "CLOSED",
  couponCopied: "Success! Your coupon has been copied!",
  currentOrder: "CURRENT ORDER",
  deliveryInfo: "DELIVERY INFO",
  discountCode: "Discount Code",
  editItemText: "Edit Item",
  editorPickup: "Editor's Pick & Customer Favorite",
  emailAddress: "Email Address*",
  enterMessage: "Enter message here.",
  entrYourMail: "Enter your email",
  facebookLink: "Facebook link",
  failureretry: "Retry",
  fingerLickin: "Finger Lickin’ Got It! Added to your cart!",
  getDirection: "Get Directions",
  giftErrTitle: "OH NO!",
  greetingGood: "GOOD",
  haveQuestion: "Still have a question?",
  invaidInputs: "Your order could not be found",
  keepBrowsing: "Keep Browsing",
  keepShopping: "Keep Shopping",
  makeItACombo: "MAKE IT A COMBO",
  nameExistMsg: "Occasion name already exists. Please choose a different name for the occasion",
  nextLocation: "next location",
  noNearestKFC: "No nearest KFC store",
  noOrderFor12: "No orders have been placed in the past 12 months.",
  offerApplied: "Offer Applied",
  offersForYou: "OFFERS FOR YOU",
  openTomorrow: "Open Tomorrow at",
  orderDetails: "order details",
  orderHistory: "Order History",
  orderItAgain: "QUICK REORDER",
  orderhistory: "Order History",
  outOfService: "Out Of Service",
  payCashTitle: "Cash on Delivery",
  personalInfo: "Personal Info",
  pleaseSelect: "Please Select",
  quickReorder: "Quick Reorder",
  savedAddress: "Saved Address",
  selectATopic: "Select a Topic",
  selectOption: "Select Your Options",
  signInButton: "Sign-in to see your saved addresses",
  signInSignUp: "Sign in / Sign up",
  signOutText1: "You’re signed Out.",
  signOutText2: "We’re gonna miss you.",
  signinButton: "Sign-in to see your saved addresses",
  singleResult: "Result for",
  takeawayFrom: "Pick up From",
  takeawayInfo: "PICK UP INFO",
  thatNotRight: "THAT AIN’T RIGHT",
  wantToModify: "Want to add or modify? ",
  yourDelivery: "Your delivery by",
  yourLocation: "Your Location",
  FeedbackEmail: "kfcfeedback@yum.com",
  addHopeHeader: "Donate ₹5.00 Tick to Add Hope.",
  addToOccasion: "Add to Occasions",
  address2Error: "Please enter a valid address.",
  addressHeader: "ADDRESS HEADER",
  alreadyMember: "Already a member?",
  browseTheMenu: "Browse The Menu",
  buttonPopOver: "Tap me to show second popover",
  cartDownArrow: "downArrow",
  cartMinusGrey: "decrease quantity",
  cartRemoveAll: "Remove All",
  cartRighttick: "Right Tick",
  checkoutAlert: "This is an error alert — check it out!",
  contentButton: "Tap me to see a content button",
  continueToPay: "Continue to Payment",
  couponSuccess: "Success! Your coupon has been applied!",
  defaultString: "to order your favorite Chicken.",
  deleteAccount: "Delete Account",
  dineInOptions: "DINE IN OPTIONS",
  editOrderType: "edit order type",
  effectiveDate: "Effective Date:",
  emailHelpText: "Please enter a valid email address.",
  emptyCardName: "Enter Full Name",
  exclusiveDeal: "EXCLUSIVE DEAL",
  generic_error: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  giftCardTitle: "GIFT CARD",
  haveAQuestion: "Have a question?",
  invalidExpiry: "Invalid Expiry Date",
  invalidQRCode: "Invalid QR code would you like to explore nearby KFC store.",
  largeCarryBag: "Large Carry Bag",
  lastNameLabel: "Last Name",
  leaveatMyDoor: "Leave at my door",
  leftArrowCaps: "Left Arrow",
  mandatorynote: "Note: * Indicates required field",
  morePageTitle: "Web Title",
  nameThisOrder: "Name this order",
  occasionTitle: "Occasion Name",
  oneItemUnaval: "Item is unavailable.",
  orderAccepted: "ORDER ACCEPTED",
  orderDateTime: "ORDER DATE & TIME",
  orderForLater: "Order for Later",
  orderPastTime: "We’re sorry, but your current order’s scheduled time has passed. Please reschedule your order time to continue.",
  paymentHeader: "PAYMENT",
  phoneHelpText: "Please enter the valid mobile number.",
  questionForUs: "Question for us?",
  refundMessage: "Your order transaction has failed and your refund is being processing. Please contant us if you have any questions.",
  removeFavMenu: "Remove From Favourite Menu",
  roundTheClock: "24x7",
  saveThisOrder: "Save This Order",
  scheduleOrder: "Schedule Order",
  selectedSlide: "selected slide",
  spinnerButton: "Tap me to see a spinner",
  thatsAllRight: "THAT AIN’T RIGHT",
  tickToAddHope: "Tick to Add Hope.",
  useMyLocation: "Use My Location",
  yourCartEmpty: "YOUR CART IS EMPTY. LET'S START AN ORDER!",
  yourPastOrder: "Your Orders",
  Congratulation: "CONGRATULATIONS!",
  Page_Title_Faq: "KFC FAQ",
  accoundSetting: "Account Settings",
  accountFavPage: "Account - Favorites",
  addToFavourite: "Add to Favourite",
  bankTextHeader: "Bank",
  browsecategory: "browse categories",
  buttonTemplate: "Template button",
  callRestaurant: "Call Restaurant",
  cardNumberText: "Card Number*",
  cartMinusBlack: "decrease quantity by 1 for",
  checkoutFaster: "CHECKOUT FASTER",
  closeGiftClose: "Close CHECK YOUR GIFT CARD BALANCE dialog",
  confirmChanges: "Confirm Changes",
  delBtnOccasion: "Delete this occasion",
  deliverycharge: "Restaurant Handling (Incl. taxes)",
  deriverArrived: "Deriver arrived",
  discardChanges: "Discard Changes",
  emptyCouponMsg: "Enter your Coupon Code.",
  emptyOccasions: "You haven’t created any occasions yet",
  emptyOccassion: "Occasion name should not be empty",
  firstNameLabel: "First Name",
  giftcardNumber: "Gift Card Number*",
  giftcardTender: "giftcard",
  giveUsYourName: "GIVE US YOUR NAME OR ORDER NUMBER WHEN YOU'RE HERE.",
  insideYourMeal: "INSIDE YOUR MEAL",
  invalidEmailId: "Invalid E-mail id",
  invalidOrderId: "Not A Valid Order Number",
  kfcLocalOffers: "Select a kfc to see local offers",
  nameOnCardText: "Name on Card*",
  nationalOffers: "National Offers",
  noteItemsAdded: "Please note your items will be added to your cart.",
  occassionLabel: "Occasion Name",
  orderDelivered: "Order delivered",
  orderFailedMsg: "Input necessary messaging here. Ut in viverra tellus enean pharetra enim",
  outForDelivery: "Out For Delivery",
  plsReviewOrder: "please review your order",
  popOverButton1: "Tap me to see first popover",
  processingYour: "PROCESSING YOUR",
  readyForPickup: "READY FOR PICK UP",
  recaptchaLabel: "Recaptcha",
  rightArrowCaps: "Right Arrow",
  searchThisArea: "Search this area",
  secureCheckout: "Secure Checkout",
  selectCarryBag: "Select large carry bag",
  startYourOrder: "START YOUR ORDER",
  subscribeEmail: "I want to know about the cool stuff at KFC on Email & SMS (I know I can unsubscribe anytime).",
  suggestionText: "Entering text into the input field will trigger the suggestions of search",
  switchToDineIn: "Switch to Dine-in",
  trackYourOrder: "Track Your Order",
  turnedNoResult: "TURNED NO RESULTS",
  MultipleResults: "Results for",
  Page_Title_Cart: "KFC Cart",
  YourKFCLocation: "YOUR KFC RESTAURANT",
  addToFavourites: "add to favourites",
  cartAddMoreFood: "Add More Food",
  cartAddMoreMenu: "Add More Menu",
  cartOffersDeals: "Apply Offers & Deals",
  categoriesImage: "Browse categories image",
  comboSubHeader1: "Would you like to make it a combo?",
  comboSubHeader2: "Select one of the options below.",
  completedOrders: "completed orders",
  continueExplore: "continue exploring our menu option",
  continuePayment: "Continue to Payment",
  currentlyClosed: "is currently closed. Please select a different store or order during working hours.",
  delAddressTitle: "Are you sure you want to remove this occasion?",
  deliveredAround: "will be delivered around",
  deliveryAddress: "Delivery Address",
  deliveryOptions: "DELIVERY OPTIONS",
  doNotSellMyInfo: "Do not sell my personal information",
  editbtnOccasion: "edit occasion name",
  emptyCardNumber: "Enter Card Number",
  emptyCartBanner: "Empty Cart Banner",
  emptyPostalCode: "Enter Billing Postal Code",
  exclusiveOffers: "Sign In to See Exclusive Offers & Deals",
  feedbackSuccess: "Success",
  giftCartMessage: "Message",
  giftPurchaseErr: "It seems there is some issue with the gift card purchase",
  invalidPhoneNum: "Invalid Phone number",
  itemUnavailable: "Unavailable",
  loadMoreFavMenu: "Load More Favourite Menu",
  mandatoryFields: " * all fields are required",
  myOccassionText: "My Occasions",
  nameOrderNumber: "GIVE US YOUR NAME OR ORDER NUMBER",
  newOffersForYou: "new offers for you!",
  otherWalletText: "Other Wallet",
  paymentdeclined: "Unfortunately, we are unable to process your payment right now. The payment has been declined by the payment provider.",
  processingOrder: "Processing your order. ready in just a second.",
  refundInitiated: "refund-initiated",
  refundinitiated: "refund-initiated",
  saveOrderFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  savedAddressMsg: "Saved this order in My Favourite Menu.",
  searchAndFilter: "Search",
  selectOrderType: "Select Order Type",
  takeawayOptions: "PICK UP OPTIONS",
  termsConditions: "Terms and Conditions",
  unavailabeItems: "Oops! Few items in your cart are temporarily unavailable. Select Add More Menu to add another item.",
  viewMoreDetails: "View More Details",
  KfcToYourCarDesc: "Avoid the hassle of walking into crowded places. We'll come to you.",
  btnRemindMeLater: "Remind Me Later",
  cancelButtonText: "Cancel",
  carousalDisabled: "carousel view disabled",
  cartOffersForYou: "Offers & deals for you",
  checkGiftBalance: "CHECK BALANCE",
  confirmSelection: "Confirm Selection",
  confirmYourOrder: "CONFIRMING YOUR ORDER.",
  contactInfoTitle: "Contact Info",
  editPersonalInfo: "Edit Personal Info",
  emailPlaceholder: "Email*",
  emptyEmailErrMsg: "Enter recipient email",
  enterYourOrderNo: "Please Enter your order Number",
  feedbackHelpText: "Please enter your feedback.",
  getOccasionEmail: "Get occasional emails about site improvements or changes",
  giftCardPurchase: "gift-card-purchase",
  giftMessageTitle: "MESSAGE",
  lastNameHelpText: "Please enter your last name",
  listviewDisabled: "listview disabled",
  morePageSubTitle: "Web Sub Title",
  netbankingString: "Netbanking",
  occasionGiveName: "We saved this order as an occasion, give it a name!",
  orderReadyInJust: "ORDER. READY IN JUST",
  outOfStockNotify: "Sorry, items in your cart has become unavailable. Please review before checkout.",
  phonePlaceholder: "Phone Number*",
  previousLocation: "previous location",
  productListModal: "Open product list modal",
  recipientEmptErr: "Invalid recipient email",
  scheduleDelivery: "Schedule delivery",
  searchByLocation: "Search by State, City, or Zip",
  selectOrderTitle: "HOW WOULD YOU LIKE TO RECEIVE YOUR ORDER?",
  signAndSaveOrder: "Sign Up & Save Order",
  storeClosedTitle: "is currently closed.",
  submitButtonText: "Submit",
  switchToDelivery: "Switch to Delivery",
  switchToTakeaway: "Switch to Pick up",
  unselectCarryBag: "unselect large carry bag",
  viewOrderHistory: "View Order History",
  SignInToSeeOffers: "Sign In to see exclusive offers & deals",
  addItemToCartText: "Added item to the cart",
  cartError_explore: "Sorry, this food is ",
  cartLineItemImage: "lineItemImage",
  closePaymentModal: "Close Select your Payment Dialog",
  deleteAccountText: "Your account has been deleted. We're gonna miss you.",
  dineInStoreClosed: "Sorry, dine-in is not currently available right now.",
  feedbackSuccessOk: "OK",
  firstNameHelpText: "Please enter your first name.",
  haveADiscountCode: "HAVE A DISCOUNT CODE?",
  invalidPostalCode: "Invalid Postal Code",
  invalidcardNumber: "Invalid Card Number",
  leaveatMyDoorDesc: "To protect you and our team, we practice contactless delivery. Your driver will leave the order at your door, knock, step away, and wait at a safe distance for you to collect your food.",
  loveToHearFromYou: "We'd love to hear from you.",
  namevalidationmsg: "special characters are not allowed",
  noStoreTextDineIn: "OOps! Sorry, there are no stores available for Dine In.",
  oneCouponPerOrder: "You can only apply one coupon per order.",
  openProductFilter: "Open product filter",
  phoneNumberStatic: "+918042754444",
  popoverDoneButton: "Done",
  postOrderAccepted: "ORDER ACCEPTED.",
  postOrderErrorMsg: "It seems there is some issue with the order status",
  priceChangeNotify: "Items in your cart have changed price.",
  refineItemsHeader: "Refine items",
  saveOrderThankYou: "Thank you for signing up!",
  surveyScreenTitle: "Survey",
  termsAndCondition: "Terms & Conditions",
  yourEmailHelpText: "Please enter your Email ID.",
  bothChangeCartMain: "NO LONGER AVAILABLE / HAVE CHANGED PRICE.",
  bothChangeCartText: "ITEMS IN YOUR CART ARE",
  cartOffersAndDeals: "Offers & Deals",
  cartRecommendTitle: "Indulgent Add-Ons",
  changedItemOneItem: "Item have changed price.",
  clearCartAwareText: "please be aware that ",
  defaultCallMessage: "Meanwhile,",
  defaultCallMessages: "please call",
  dineInNotAvailable: "Dine-in is not available would like to go for Pick up instead?",
  emptyFavouriteMenu: "You haven’t favorited any items yet",
  errorMessageClosed: "Sorry , the restaurant is closed on the date and time you have chosen . Choose another date and time",
  favouriteMenuTitle: "MY FAVORITE MENU",
  giftCardNumberText: "Gift Card Number*",
  invalidEmailErrMsg: "Invalid email.",
  invalidQRCodeError: "Invalid QR code, would you like to explore nearby KFC store",
  itemAddedToCartMsg: "Please note your items will be added to your cart.",
  messageplaceholder: "Leave a message for recipients here.",
  noTimeSlotsMessage: "Timeslots are not available right now",
  postOrderScheduled: "scheduled!",
  purchasefailuremsg: "It seems there is some issue with the Gift card purchase",
  readyInJustASecond: "READY IN JUST A SECOND.",
  restaurantHandling: "Restaurant Handling(Incl. taxes)",
  searchResultHeader: "results for",
  selectYourLanguage: "Select Your Language",
  somethingWentWrong: "Something went wrong please try after sometime",
  storeUseMyLocation: "Use My Location",
  unsupportedBrowser: "This browser is not supported by KFC App. Please download these browsers to use this app.",
  vehicleInformation: "Enter your vehicle information (brand, color, etc)",
  viewMapErrorButton: "View Map",
  weThinkYouLoveThis: "We Think You'll love these",
  MyDeliveryAddresses: "My Delivery Addresses",
  address2Placeholder: "Apartment, suite, unit, building, floor",
  bothChangeCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  categoriesImageText: "Browse categories",
  changeOrderSettings: "Change Order Settings",
  clearCartActionText: "your cart will be cleared ",
  createAccountToSave: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND CHECKOUT FASTER",
  creditDebitCardText: "Credit / Debit Card",
  defaultErrorMessage: "Thank you for visiting. We are fixing this right away. Will be back soon.",
  deleteOccassionText: "Delete this Occassion",
  deliveryInstruction: "Please Enter Delivery Instruction",
  deliveryStoreClosed: "Sorry, delivery is not currently available right now.",
  doubleTapToActivate: "double tap to activate",
  emptyFullNameErrMsg: "Enter your full name.",
  emptyYourNameErrMsg: "Please enter your name.",
  favoriteItemMessage: "Item added to favorites",
  findClosestLocation: "Find your closest location.",
  giftCardInformation: "GIFT CARD INFORMATION",
  giftCardPurchageMsg: "Your gift card has been purchased and details emailed to the recipient",
  insufficientBalance: "Insufficient Balance",
  lastNamePlaceHolder: "Last Name*",
  noStoreTextTakeaway: "OOps! Sorry, there are no stores available for Pick up.",
  occassionNameExists: "Occasion name already exists",
  phcWheelChairAccess: "Wheel chair access",
  pleaseEnterLocation: "Please enter your location",
  removeFromFavourite: "Remove From Favourite",
  seeFullOrderHistory: "See Full Order History",
  selectOrderSubTitle: "Menu availability and pricing may vary between order types.",
  splahScreenGreeting: "NICE MEETING YOU",
  takeawayStoreClosed: "Sorry, pick up is not currently available right now.",
  unavailableCartMain: "NO LONGER AVAILABLE",
  unavailableCartText: "SORRY, SOME ITEMS ARE",
  unsuccessfulPayment: "It seems there is some issue with the order status",
  usernameplaceholder: "Your Name*",
  Page_Title_Gift_Card: "KFC Gift Card",
  changeYourOrderTitle: "CHANGE YOUR ORDER",
  deliveryInstructions: "Enter delivery instructions(Optional)",
  dispositionUnavalMsg: "Sorry, %disposition% is currently unavailable. Please change your order settings below to complete your order.",
  editorPickupSubTitle: "Receive Editor updates on new and upcoming releases and the best reviews from customers like you",
  errorMessageInactive: "We are sorry not to be able to process your request at this moment. Please call the restaurant directly or try again after some time to place the order",
  favoriteStoreMessage: "This store is marked as your favorite",
  firstNamePlaceholder: "First Name*",
  invalidAddressHeader: "Sorry, we could not identify your address. Please be more specific with your location.",
  largeCarryBagContent: "₹5.00 Tick to add a large carry bag.",
  myFavouriteMenuTitle: "My Favorite Menu",
  optionalEmailAddress: "Email Address",
  orderTakeAwayBtnText: "Order Pick up",
  priceChangedCartMain: "CHANGED PRICE.",
  priceChangedCartText: "ITEMS IN YOUR CART HAVE",
  scheduleForYourOrder: "Schedule for your order",
  selectYourBankHeader: "Select Your Bank",
  suggestedSearchTerms: "Suggested Search Terms",
  surveyScreenQuestion: "How was your order?",
  takeawayNotAvailable: "Pick up is not available would like to go for Dine-in instead?",
  unavailableCartQuery: "AT THIS LOCATION. DO YOU WANT TO KEEP THESE SETTINGS?",
  useremailplaceholder: "Your Email*",
  userphoneplaceholder: "Your Phone Number*",
  willBeReadyForPickup: "Will be ready for pick up by",
  Page_Title_Post_Order: "KFC Post Order",
  addHopeSubDescription: "Our goal is to feed 20 millions meals by 2022.",
  addresss2InvalidError: "Special characters are not allowed except ,/#@-().",
  billingPostalCodeText: "Billing Postal Code*",
  checkGiftBalanceTitle: "Check your Gift card balance",
  clearCartCompleteText: "to complete this order.",
  editCurrentRestaurant: "edit your kfc restaurant",
  invalidFullNameErrMsg: "Invalid full name.",
  maxOrderAmountMessage: "The max order amount for store is",
  minOrderAmountMessage: "The min order amount for store is",
  myFavouriteBrowseMenu: "Browse the menu",
  pleaseReviewYourOrder: "Please review your order",
  priceChangedCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  purchasefailureheader: "OH NO!",
  searchDiffAddressText: "Search for a different address",
  storeClosedButtonText: "Store Closed",
  testingLingualSupport: "English",
  unFavoriteItemMessage: "Item removed from favorites",
  wantToKnowPlaceholder: "Type your message here.",
  OccasionNameValidation: "Occasion name has to be at least 3 characters length",
  addPaymentMethodHeader: "Add Payment Method",
  cartCouponErrorMessage: "Sorry, this code isn’t available right now.",
  connectWithASpecialist: "Connect with a specialist for answers.",
  emptyPhoneNumberErrMsg: "Enter your phone number.",
  feedbackSuccessMessage: "Thanks for submitting your query. We will get back soon.",
  giftcardpaymentfailure: "Unfortunately, we can't process this payment, as the payment has been declined by your credit card Issuer or bank",
  myFavouriteMenuNoItems: "You haven't favorited any items yet",
  myOccassionUnavailable: "You haven't created any occasions yet",
  orderNumberPlaceHolder: "Order Number*",
  placePinAtYourLocation: "Place the pin at your location.",
  selectYourWalletHeader: "Select Your Wallet",
  tickToAddLargeCarryBag: "Tick to add a large carry bag.",
  unFavoriteStoreMessage: "This store is removed from your favorites",
  addressSuggestionHeader: "Does this address look correct?",
  closeStoreModelSubTitle: "Please select a different store or order during working hours.",
  dineInPickDifferentTime: "Dine-In is not available for the selected time, please select different time.",
  emptySearchResultHeader: "Your search did not end up in any results",
  invalidCharactersErrMsg: "Numbers and special characters are not allowed.",
  invalidYourEmailErrText: "Please Enter Correct Email Address",
  lookingForSpecificOrder: "Looking for a specific order?",
  pickupPickDifferentTime: "Pick up is not available for the selected time, please select different time.",
  savedOrderScheduleOrder: "Scheduled Order ",
  surveyScreenSubQuestion: "Write a review",
  Page_Title_Cart_Checkout: "KFC Checkout",
  communicationPreferences: "Communication Preferences",
  editOccassionDialogTitle: "Edit Occasion Name",
  enterQuestionPlaceholder: "| Enter question or search term",
  enterYourDeliveryAddress: "Search for area, street name…",
  invalidPhoneNumberErrMsg: "Invalid phone number.",
  kfcSignInExclusiveOffers: "Sign in to see more exclusive offers & deals",
  noStoresWithDineInHeader: "Sorry, dine-in is not currently available for this address.",
  noStoresWithPickupHeader: "Sorry, pick up is not currently available for this address.",
  phonenumberEmptyHelpText: "Please enter your phone number.",
  savedOrderInFavoriteMenu: "Saved this order in My Favorite Menu.",
  deliveryPickDifferentTime: "Delivery is not available for the selected time, please select different time.",
  doubleTaptoStartYourOrder: "double tap to open start your order page",
  giftcardCheckbalnaceTitle: "CHECK YOUR GIFT CARD BALANCE",
  invalidPhoneNumberErrText: "Not a valid phone number",
  invalidVehicalInformation: "Invalid Vehicle Information",
  multipleCustomizationText: "This item has multiple customizations added. Proceed to cart to remove item?",
  recipientemailplaceholder: "Recipient Email*",
  createAndAccountSaveOrders: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND",
  dineInNoStoresFoundMessage: "No restaurant has been found for Dine-In. Please try another location.",
  dineInUnavailableErrorText: "Dine-In is currently unavailable for your location. Would you like to order pick up instead?",
  invalidDeliveryInstruction: "Invalid Delivery Instruction",
  invalidPhoneErrforGiftCard: "Invalid Phone Number, Please enter valid Phone Number",
  noStoresWithDeliveryHeader: "Sorry, delivery is not currently available for this address.",
  pickupNoStoresFoundMessage: "No restaurant has been found for Carryout. Please try another location.",
  saveOrderAndCheckoutFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  unidentifiedAddressMessage: "Sorry, we could not identify your address. Please be more specific by moving the map.",
  enterYourOrderNoPlaceHolder: "Enter Your Order Number",
  recipientEmptyEmailHelpText: "Please enter the Recipient's Email ID.",
  selectYourOtherWalletHeader: "Select Your Other-Wallet",
  takeAwayUnavalibleErrorText: "This KFC is not accepting online orders. Please try another KFC near you or check back later.",
  cartRemoveSingleItemNextText: "from your cart?",
  cartRemoveSingleItemPrevText: "Are you sure to remove",
  deliveryNoStoresFoundMessage: "Hey, the nearest KFC store to your location is currently not accepting online orders. Please try another location or check again later.",
  deliveryUnavailableErrorText: "Delivery is currently unavailable for your location. Would you like to order pick up instead?",
  invalidRecipientEmailErrText: "Please Enter Correct Email Address",
  areYouSureToDeleteAccountText: "Are you sure, you want to delete your account?",
  cartRemoveAllConfirmationtext: "Are you sure to remove all of items in your cart?",
  selectYourPaymentScreenHeader: "Select Your Payment",
  cartError_sorryFoodNotAvailable: " currently, continue exploring.",
  noStoresWithDeliveryHeaderError: "Delivery is currently unavailable for your entered location. Could you be more specific with address or would you like to try pick up instead?",
  pleaseEnterYourVehicalInformation: "Please Enter Your Vehicle Information",
  cartRemoveLineItemConfirmationtext: "Item has been removed from your cart.",
  takeAwayUnavalibleErrorTextWithCTA: "Pick up is currently unavailable for your location. Would you like to try a different address?",
  addressBoxPlaceHolderForSearchStore: "Search by State, City or Zip",
  deliveryUnavailableErrorTextWithCTA: "Sorry, we could not identify your address. Please be more specific with your location.",
  dineInStoresWithoutAnyServiceHeader: "Sorry, dine-in is not currently available right now. Would you like to schedule for later?",
  pickupStoresWithoutAnyServiceHeader: "Sorry, pick up is not currently available right now. Would you like to schedule for later?",
  deliverystoresWithoutAnyServiceHeader: "Sorry, delivery is not currently available right now. Would you like to schedule for later?",
  ERROR_ALT: "error",
  welcomeBackTo: "WELCOME BACK TO ",
  unchecked: "Unchecked",
  atWithSpace: " at ",
  Page_Title_Offers: "KFC Deals and Offers",
  Page_Title_Login: "KFC Login",
  Page_Title_Help: "KFC Help",
  Page_Title_Checkout: "KFC Checkout",
  Page_Title_Payment_Failure: "KFC Payment Failure",
  Page_Title_Payment_Success: "KFC Payment Success",
  Page_Title_Payment_Status: "KFC Payment Status",
  Page_Title_Our_Adds: "KFC Our Adds",
  Page_Title_ContactUs: "KFC Contact Us",
  Page_Title_TermsOfUse: "KFC Terms of use",
  Page_Title_Terms_Conditions: "KFC TERMS & CONDITIONS",
  Page_Title_FAQ: "KFC FAQ",
  Page_Title_Privacy_Policy: "KFC Privacy Policy",
  Page_Title_Sign_out: "KFC Signout",
  Page_Title_Account: "KFC Account",
  Page_Title_Not_Found: "KFC Page not found",
  errorDeleting: "Error in deleting account",
  tryAgain: "Please Try Again",
  orderReceipt: "ORDER RECEIPT",
  NoBasketIdErrorMessage: "We were not able to fetch your cart details due to an unexpected error. To continue further please select the store to continue.",
  Page_Order_Details: "KFC - Order Details",
  yourAccount: "your account",
  doYouWant: "Do you want to",
  permanently: "PERMANENTLY",
  openToday: "Open Today",
  readyForDineIn: "READY FOR DINE-IN",
  dineInText: "will be ready for Dine-in by",
  paymentPreValidationFailed: "Unfortunately, we are unable to process your payment right now. Please try with a different payment option.",
  mealOptions: "MEAL OPTIONS",
  totalCost: "Total cost:",
  userRefreshWarning: "Your session is going to expire soon. Please continue your work once your page reloads",
  quantity: "QUANTITY",
  mainEntree: "Main Entree",
  comboSubHeader: "Would you like to make it a combo? Select one of the options below.",
  exploreFoodItem: "Explore our various other food items",
  selectQuantity: "SELECT QUANTITY",
  addNewProduct: "Add new product",
  updateCart: "Update Cart",
  editSelections: "EDIT SELECTIONS",
  editSelectionsBtnText: "Edit selections",
  itemUpdated: "ITEM UPDATED",
  continueAsGuest: "Continue As Guest",
  tokenExpired: "Your session has expired. Please relogin or continue as guest.",
  editQuantity: "EDIT QUANTITY",
  cartEditLineItemConfirmationtext: "You have successfully edited an item in the cart.",
  estimatedArrival: "Estimated Arrival",
  deliveredAt: "DELIVERED AT",
  orderReceived: "ORDER RECEIVED",
  enjoyMeal: "ENJOY YOUR FINGER LICKIN' MEAL!",
  askForOTP: "RIDER WILL ASK YOU FOR THIS OTP ON ARRIVAL",
  orderGettingReady: "WE’RE GETTING YOUR ORDER READY",
  foundDriver: "WE’VE FOUND A RIDER",
  cancelOrder: "SORRY, WE’VE HAD TO CANCEL YOUR ORDER.",
  cancelOrderRefund: "WE WILL REFUND YOUR PAYMENT IN FULL WITHIN ",
  businessDays: " BUSINESS DAYS",
  preparedBy: "PREPARED BY",
  instructions: "INSTRUCTIONS",
  contactKFC: "CONTACT KFC",
  kfcRestaraunt: "KFC Restaurant",
  contact: "Contact",
  isOnTheWay: "is on his way to your address",
  findingDriver: "Finding a rider for the order",
  arrvingSoon: " is arriving now",
  call: "Call",
  instagram: "Instagram",
  footer_links: "footer-links",
  social_icons: "social-icons",
  facebook: "Facebook",
  twitter: "Twitter",
  internal: "internal",
  external: "external",
  deliveryFee: "Delivery Fee",
  orderOnTheWay: "ORDER ON THE WAY",
  driverArriving: "RIDER ARRIVING",
  deliveryAddressText: "DELIVERY ADDRESS",
  hours: "Hours:",
  reckOnText: "reckon you’ll want to order THIS again?",
  reorderFavourites: "receive special offers and REORDER YOUR FAVOURITES",
  hereToHelp: "WE'RE HERE TO HELP IF YOU REQUIRE MORE INFORMATION ",
  saveToFavouriteOrder: "Save to Favourite Orders",
  braze: "Braze",
  ga4: "GA4",
  gstIncluded: "Total (GST INCLUDED)",
  cashOnDeliveryMsg: "Sorry for the inconvenience, your order has been cancelled by our store.",
  onlinePayment: "If you have made online payment,",
  onlinePaymentMsg: "a refund will appear on your original payment source within 7-10 business days.",
  pdpAddToCart: "Add to Cart",
  createKfcAccount: "Create a KFC Account",
  scheduledTime: "Scheduled time",
  locator: "Locator",
  totalPriceErrorMessage: "Your cart value exceeds the max. allowed limit of",
  weAreWorkingOn: "We are working on",
  ordersNow: "orders now.",
  yourOrderIsScheduled: "YOUR ORDER IS SCHEDULED",
  currentOrders: "CURRENT ORDERS",
  pickupDetails: "Pickup Details",
  trackDelivery: "Track Delivery",
  trackOrders: "Track Orders",
  deliveryOrder: "DELIVERY Order",
  hasBeenConfirmed: "has been confirmed for delivery",
  weAreWorking: "We are working on",
  orders: "orders",
  now: "now",
  hasScheduled: "has scheduled",
  signOutFailText1: "You’re signed out",
  signOutFailText2: "Kindly Sign In again",
  playNow: "PLAY NOW",
  categoryNotAvailable: "CATEGORY ",
  notAvailable: "NOT AVAILABLE",
  oopsWentWrong: "OOPS Something went WRONG!",
  retainCart: "Please add your food again to cart",
  savedFavStore: "Saved to your favorite store",
  apiFailurePopupHeader: "SOMETHING WENT WRONG!",
  apiFailurePopupDescription: "Whoops, something went wrong! Please try again.",
  appCrashPopupHeader: "SOMETHING WENT WRONG!",
  appCrashPopupDescription: "Whoops, something went wrong! Please restart the app",
  networkIssuePopupHeader: "SOMETHING WENT WRONG!.",
  networkIssuePopupDescription: "We’re sorry, we’re having trouble with your connection. Please check your WiFi or cellular service and try again.",
  showDifferenceInLocalized: "Would you like to update your location for Delivery?",
  showNonlocalized: "Start a Dine in order now, or browse the menu",
  updateLocationBtn: "Yes, Update location",
  usePreviousAddress: "No, previous location",
  startOrderBtn: "Start order",
  toastNoStoreMsg: "There aren’t any nearby \nstores available right now",
  ToastStoreClosedMsg: "We are operational from",
  lastAddressMsg: "Your last used location was:",
  allowLocationMsg: "Allow Location permission for \n local store menu and promos",
  turnOn: "Turn on",
  allowLocationBtn: "Allow Location",
  takeAwayValue: "takeaway",
  turnOnMsg: "Turn on location services for \nlocal store menu and promos",
  openStoreMsg: "You can still browse the menu\n for when stores are open",
  noStoreFound: "You can still browse the menu for when there’s a store nearby",
  commonModalClosedMsg: "Sorry, There are no stores OPEN \n in your area right now",
  localisedMsg: "You don’t seem to be near your\n previously used location",
  CommonOpenStoreHeading: "IS AVAILABLE AT\n your nearest store RIGHT NOW.",
  localisedToastMsg: "Your order is set up to",
  basedStoreAvailableMsg: "based on store availability",
  night: "night",
  day: "day",
  takeAwayTitle: "ONLY TAKEAWAY IS AVAILABLE AT YOUR NEAREST STORE RIGHT NOW.",
  takeAwayContent: "Start a Takeaway order now, or browse the menu",
  takeAwayToastMsg: "Your order is set up to takeaway based on store availability",
  dineInTitle: "ONLY DINE IN IS AVAILABLE AT YOUR NEAREST STORE RIGHT NOW.",
  dineInContent: "Start a Dine in order now, or browse the menu",
  dineInToastMsg: "Your order is set up to dine in based on store availability",
  deliveryToastMsg: "Your order is set up to delivery based on store availability",
  noStoreTitle: "SORRY, THERE ARE NO STORES IN YOUR AREA RIGHT NOW",
  noStoreContent: "You can still browse the menu for when there's a store nearby",
  noStoreToastMsg: "There aren't any nearby stores available right now",
  closedStoreTitle: "SORRY, THERE ARE NO STORES OPEN IN YOUR AREA RIGHT NOW",
  closedStoreContent: "You can still browse the menu for when stores are open",
  closedStoreToastMsg: "We are operational from",
  localizationChangeTitle1: "YOU DON'T SEEM TO BE NEAR YOUR ",
  localizationChangeTitle2: "PREVIOUSLY USED ADDRESS",
  localizationChangeContent: "Would you like to update your location for Delivery?",
  previousAddress: "Your last used address was:",
  Page_Title_Caution_Notice: "KFC Cautious Notice",
  setLocationText: "Allow location access for local store menu and promos",
  locationAlertMessage: "Go to your browser settings and enable online.kfc.co.in for local store menu and promos",
  sitemapPageTitle: "KFC Sitemap",
  menu: "Menu",
  stores: "My Stores",
  otherPages: "Other Pages",
  toMsg: "to",
  indOnMap: "Find on map",
  youHave: "You have",
  locationDeniedUseMyLocation: "KFC from accessing your location. Go to your",
  appSettings: "app settings",
  allowText: "and allow KFC to Use My Location.",
  orText: "OR",
  otpText: "RIDER WILL ASK YOU FOR THIS OTP ON ARRIVAL",
  googlepay: "google-pay",
  textAfterImage: "text after image",
  resetInvalidBasketMessage: "Something went wrong, please enter your address again to order.",
  reOrderAgain: "Quick Reorder",
  welcomeBackText: "Welcome Back",
  review_Condition: "Please review the conditions below.",
  setLocation: "Set Location",
  seeOffersForYou: "SEE OFFERS FOR YOU",
  noOrderHistoryMsg: "Your Bucket is empty. Let’s start an order!",
  enterDifferentOrderName: "There is already another favourite with this name. Enter a different order name.",
  postProcessIngGstIncluded: "Total (GST INCLUDED):",
  aditionalAddress: "Apt / Suite / Floor (Optional)",
  thatDeliverToYou: "KFC that deliver to you",
  dispositionItemNotAvailable: "Not Available for ",
  checkBackAgain: "Check back again soon for new Offers and Deals just for you",
  thatsAllForNow: "THAT’S ALL FOR NOW",
  itsBusyAndItsTakingAWhileToFindADriver: "It’s busy and it’s taking a while to find a driver...",
  hasAcceptedToDeliverYourOrder: "has accepted to deliver your order",
  deliveryDriver: "DELIVERY DRIVER",
  IsOnHisWayToTheRestaurant: "is on his way to the restaurant",
  makingOrderFresh: "we’re MAKING your order FRESH",
  readyToMakeOrder: "we’re ready TO MAKE YOUR ORDER",
  foundDeliveryDriver: "we’VE FOUND A DELIVERY DRIVER",
  findNearByRestaurant: "Find nearby restaurant",
  sorryText: "sorry,",
  storeOfflineMain: "can no longer serve this order.",
  emergencyStoreCloseMain: "is currently closed due to unforseen circumstances",
  selectDifferentStore: "Please select a different restaurant or keep browsing the menu",
  name: "Name",
  mobileNumber: "Mobile Number",
  kfcMenu: "KFC Menu",
  chooseAnotherWay: "Choose another way to pay",
  orderSummary: "ORDER SUMMARY",
  copyRight: "Copyright © KFC India. 2022 All Rights Reserved. Version {{appVersion}} ({{buildNumber}})",
  totalOrderErrorBetweenlimit: "Your cart value should be between",
  signInAccount: "SIGN IN TO YOUR ACCOUNT",
  clickPlaceOrderConfirmAgree: "By clicking on a Place Order, you confirm that you agree to our",
  termsOfUse: "Terms of use",
  privacy: "Privacy",
  storeCloseSoonMain: "is closing in 45 minutes",
  storeCloseSoonContent: "Complete your order and checkout within\n 15 minutes, or find another nearby store.",
  findNearByStoreTxt: "Find nearby store",
  completeOrderButtonText: "Complete order",
  continueToMyCart: "Continue to My Cart",
  labelName: "Name",
  favouriteNameLengthError: "Occasion name has to be at least 3 characters length",
  nameIsInvalid: "Name cannot contain special characters.",
  saveAddress: "SAVE THIS DELIVERY ADDRESS TO YOUR ADDRESS BOOK",
  saveAddressBtn: "Save Delivery Address",
  savedYourItemsInCart: "We have saved your items, pls visit during the",
  paymentFailedTitle: "We haven’t been able to process your order",
  paymentFailedSubtitle: "If payment was taken it will be refunded. Please review your order and options.",
  paymentFailedHeader: "PAYMENT",
  returnToCart: "Return to cart",
  returnToCheckout: "Return to checkout",
  chooseAnotherWayToPay: "Choose another way to pay",
  previewPDF: "Preview PDF",
  pickUpTime: "PICK UP TIME",
  deliveryTime: "DELIVERY TIME",
  selectPickupTime: "Select pick up time",
  scheduledTimePassed: "Your scheduled time has passed, please select a new time to proceed.",
  breakfastMenu: "Breakfast menu available till 11am",
  showNonlocalizedDineIn: "Start a Dine in order now, or browse the menu",
  showNonlocalizedTakeaway: "Start a Takeaway order now, or browse the menu",
  selectDeliveryTime: "Select delivery time",
  rescheduleOrderTime: "Reschedule Order Time",
  selectAnotherTime: "Select another time to receive your order.",
  deliveryLocation: "DELIVERY LOCATION",
  removeAllUnavailableItem: "Remove all unavailable items",
  menuKickedInUnavailableCart: "Lunch menu has kicked in",
  removeUnavailableItemsInCart: "remove unavailable items in cart",
  checkoutUnavailable: "Items in your cart are currently available. Please remove the items from your",
  toContinue: "to continue.",
  scheduleTimeCrossed: "Your scheduled\n order time has passed",
  scheduledCaps: "SCHEDULED",
  deeplinkCategoryNotAvailable: "Sorry, THIS CATEGORY IS NOT AVAILABLE FOR THE SELECTED RESTAURANT.",
  promoAddToCart: "Add to Order",
  storesNotServingCurrently: "Sorry! Your store is not serving orders currently",
  mobileNumberWithAstrick: "Mobile Number*",
  orderScheduled: "ORDER SCHEDULED",
  storeClosedAndPickUpApplied: "The store is currently closed, the next available pick up time has been applied",
  legalInfoPLPFooter1: "The average adult daily intake is 8700kJ.",
  legalInfoPLPFooter2: "^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contains caffeine. Mountain Dew Freeze is not recommended for children, pregnant or lactating women or individuals sensitive to caffeine.",
  mobileToolTipMessage: "Phone number required for service based messaging around your order.",
  goodMorning: "Good Morning",
  goodAfternoon: "Good Afternoon",
  noKfcNearYou: "Sorry, there is no KFC near you",
  meetAtVehicle: "Meet at vehicle",
  couponErrMsgBSDE0022: "This coupon code is already redeemed.",
  couponErrMsgBSBR003: "This coupon code is incorrect.",
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  sunday: "sunday",
  editAddress: "EDIT DELIVERY ADDRESS",
  addNewAddress: "Add New Addresses",
  signedOut: 'You’re signed Out. We’re gonna miss you.',
  kfcStore: 'KFC store',
  outOfStockProductText: 'A product or ingredient is currently unavailable. Please review the required selections below to add to order.',
  addressLabel: 'Address',
  postalCode: 'Postal Code',
  cityTown: 'City / Town',
  state: 'State',
  deliveryInstructionAddress: 'Delivery Instructions',
  makeDefaultAddress: 'Make this my default address'
}, _defineProperty(_translation, "aditionalAddress", 'Apt / Suite / Floor (Optional)'), _defineProperty(_translation, "labelPostalCode", "Postal Code"), _defineProperty(_translation, "thereNoFriedText", "THERE'S NO FRIED"), _defineProperty(_translation, "chickenOnThisPage", "CHICKEN ON THIS PAGE"), _defineProperty(_translation, "giftCardPurchaseSuccess1", "YOUR GIFT CARDS"), _defineProperty(_translation, "giftCardPurchaseSuccess2", "ARE ON THE WAY"), _defineProperty(_translation, "giftCardPurchaseMsg", "Your reciepients will recieve an SMS shortly."), _defineProperty(_translation, "returnToGiftCards", "Return to Gift Cards"), _defineProperty(_translation, "tipExceedsSubtotal", 'Tip exceeds Subtotal'), _defineProperty(_translation, "noResults", "RETURNED NO RESULT"), _defineProperty(_translation, "serves", "Serves"), _defineProperty(_translation, "myFavouritelabel", "MY FAVOURITE STORES"), _defineProperty(_translation, "myDeliveryAddresses", "MY DELIVERY ADDRESSES"), _defineProperty(_translation, "yourorders", "YOUR ORDERS"), _defineProperty(_translation, "orderAgainBtn", 'Order Again'), _defineProperty(_translation, "quoteOrderNumber", 'QUOTE YOUR ORDER NUMBER #'), _defineProperty(_translation, "cardValidatingTitle", 'VALIDATING'), _defineProperty(_translation, "newCardText", 'NEW CARD'), _defineProperty(_translation, "cardValidationDesc", "We're validating your card with payment provider"), _defineProperty(_translation, "removeGiftCard", "REMOVE GIFT CARD"), _defineProperty(_translation, "giftCardContent", 'Are you sure you would like to remove this Gift Card?'), _defineProperty(_translation, "removeVoucher", 'REMOVE VOUCHER'), _defineProperty(_translation, "voucherContent", 'Are you sure you would like to remove this Voucher?'), _defineProperty(_translation, "giftCardMealFullyCovered", "Woohoo! Your Gift Card has covered your meal."), _defineProperty(_translation, "voucherMealFullyCovered", 'Woohoo! Your voucher has covered your meal.'), _defineProperty(_translation, "voucherAboveSubtotal", 'Vouchers are single use. Balance above meal subtotal can not be used again.'), _defineProperty(_translation, "giftCardAboveSubtotal", 'Woohoo! Your Gift Card has covered the meal. Use your remaining balance another time.'), _defineProperty(_translation, "maxSubTotalValueCovered", 'Maximum order subtotal limit has been reached.'), _defineProperty(_translation, "maxVoucherLimitExceeded", 'The maximum number of Gift vouchers has been applied.'), _defineProperty(_translation, "giftCardToast", "Gift Card Removed"), _defineProperty(_translation, "voucherToast", "Voucher Removed"), _defineProperty(_translation, "giftCardVoucherContent", "The added vouchers/gift cards will be cleared if you update the cart. Do you want to continue?"), _defineProperty(_translation, "removeGiftCardVoucher", "CLEAR VOUCHER/GIFT CARD"), _defineProperty(_translation, "postOrderCouponFailure", "Your time to redeem a gift card or voucher has expired. Please re-apply at Cart and proceed to Checkout."), _defineProperty(_translation, "reApplyGiftCardOrVoucher", 'Please re-apply a valid gift card or voucher code to your order.'), _defineProperty(_translation, "savedCardPaymentTitle", "Saved cards"), _defineProperty(_translation, "otherPaymentTitle", "Use Other Payment Method"), _translation);
exports.translation = translation;